import { DownloadOutlined, EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Button, Card, Image, Space, Typography } from 'antd';
import React, { memo } from 'react';

const { Text } = Typography;

/**
 * Memoized component for displaying a file item in the requirements list
 * @param {Object} props - Component props
 * @param {Object} props.file - File object with details
 */
const FileListItem = memo(({ file }) => (
    <Card
        hoverable
        cover={
            file.type === "image" ? (
                <Image
                    alt={file.fileNumber}
                    src={file.url}
                    style={{ height: 200, objectFit: 'cover' }}
                    preview={false}
                    onClick={() => window.open(file.url, '_blank')}
                />
            ) : (
                <div
                    style={{ height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f5f5f5' }}
                    onClick={() => window.open(file.url, '_blank')}
                >
                    <FilePdfOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />
                </div>
            )
        }
        actions={[
            <Button
                key="view"
                type="text"
                icon={<EyeOutlined />}
                onClick={() => window.open(file.url, '_blank')}
            />
        ]}
    >
        <Card.Meta
            title={file.fileNumber}
            description={
                <Space direction="vertical" size={0}>
                    <Text type="secondary">Format: {file.format.toUpperCase()}</Text>
                    <Text type="secondary">Uploaded: {new Date(file.createdAt).toLocaleDateString()}</Text>
                </Space>
            }
        />
    </Card>
));

export default FileListItem;